const state = {
  describeContent: {}
}

const mutations = {
  SET_DESCRIBE_CONTENT(state, val) {
    state.describeContent = val
  }
}

export default {
  namespaced: true,
  state,
  mutations,
}